'use client'

import { ReactNode, useEffect, useState } from 'react'
import Image from 'next/image'
import { cn } from '@desoutter/uikit'
import { ArticleShieldProviderTranslationsFragment } from './ArticleShieldProvider.generated'

type ArticleShieldProps = {
	slug: string
	restricted: boolean
	translations: ArticleShieldProviderTranslationsFragment
	children: ReactNode
}

export default function ArticleShieldProvider({
	slug,
	restricted,
	translations,
	children,
}: ArticleShieldProps) {
	const [isRestricted, setRestricted] = useState(restricted)

	useEffect(() => {
		const paywall = JSON.parse(localStorage.getItem('paywall') || '[]')

		if (isRestricted) {
			setRestricted(!paywall.includes(slug))
		}
	}, [])

	return (
		<>
			<div
				className={cn({
					'relative max-w-[800px] h-[360px] mx-auto overflow-hidden':
						isRestricted,
				})}
				style={{
					backgroundImage:
						'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
				}}
			>
				{children}

				{isRestricted && (
					<div className="absolute top-0 left-0 right-0">
						<div
							className="w-full h-[360px]"
							style={{
								backgroundImage:
									'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
							}}
						/>
					</div>
				)}
			</div>
			{isRestricted && (
				<div className="max-w-[800px] max-sm:h-[1150px] mx-auto mb-16 pb-36 flex flex-col items-center w-full px-8 md:px-24 py-14 bg-foreground rounded-2xl gap-8 z-50">
					<Image src="/images/lock.svg" alt="lock" width="56" height="56" />
					<div className="flex flex-col">
						<div className="text-foreground">
							<div className="h4text-center">
								{translations.thisContentIsRestricted}
							</div>
							<p className="max-w-[247px] text-center mx-auto">
								{translations.pleaseEnterYourEmailAddress}
							</p>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
